import React from 'react';
import { useFetchData } from 'components/hooks';
import CONTENT_TYPES from 'globalConst/contentTypes-const';
import PropTypes from 'prop-types';

/**
 * HOC to inject correct station slug based on tag reference
 *
 * @param {Component} WrappedComponent
 */
export default function (WrappedComponent) {
  const Component = (props) => {
    const { slug } = props;
    const { data, isLoading } = useFetchData({
      slug,
      contentTypeId: CONTENT_TYPES.BRAND,
    });

    let refOverviewSlug = null;
    if (!isLoading && Array.isArray(data?.refs)) {
      const collections = data.refs
        .filter(({ contentTypeId }) => ['overviewCollection'].includes(contentTypeId))
        .map(({ slug }) => ({
          slug,
        }));

      refOverviewSlug = collections[0]?.slug;
    }
    return isLoading ? null : <WrappedComponent {...props} slug={refOverviewSlug} />;
  };

  Component.propTypes = {
    slug: PropTypes.string,
  };
  return Component;
}
